<svg-icon class="ui-dialog-close" src="/assets/icons/cross-thing.svg" uiDialogClose></svg-icon>

<h3>
  <span>Upload</span>
  <span *ngIf="filesReady()">complete</span>
</h3>
<file-list *ngIf="files.length" [files]="files" (removeFile)="removeFile($event)"></file-list>
<div class="pages" *ngIf="files.length" [hidden]="!filesReady() || files.length < 2">
  <b>{{ uploadedFiles }}</b>
  <span i18n>{uploadedFiles, plural, =1 {File uploaded} other {Files uploaded}}</span>
</div>
<div *ngIf="!files.length">
  <span>Upload files for processing</span>
</div>

<p class="ui-input-error" *ngIf="error" [ngSwitch]="error" [class.visible]="error">
  <span *ngSwitchDefault>{{ errorDescription }}</span>
</p>
<div class="actions">
  <button type="button" class="blank more" (upload)="uploadFiles($event)">
    Load more...
  </button>
  <button type="button" *ngIf="canShowSettings" class="blank more" (click)="showSettings()">
    Settings
  </button>
  <button type="button" *ngIf="skipCreateDialog" class="default" [disabled]="!canStartProcess" (click)="startProcess()">
    Start processing
  </button>
  <button type="button" *ngIf="showCreateDialog" class="default" [disabled]="!filesReady()" (click)="next()">
    Next
  </button>
</div>
<ui-loading *ngIf="isLoading"></ui-loading>
